import React, { useState } from 'react';
import { ISupplierDocumentUploadPolicy } from '../../Models/ISupplierDocumentUploadPolicy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const buildSummary = (policy?: ISupplierDocumentUploadPolicy) => {
    if (!policy) return 'unavailable';
    const extensionsText = policy.allowedExtensions.map(extension => extension.replace(/^\./, '').toUpperCase()).join(', ');
    const maxSizeMb = policy.maximumFileSizeBytes / (1024 * 1024);
    return `Allowed file types: ${extensionsText}. Maximum file size: ${maxSizeMb} MB.`;
};

const SupplierDocumentUploadGuidance = ({ policy, isAdmin, isSupplier }: { policy?: ISupplierDocumentUploadPolicy, isAdmin?: boolean, isSupplier?: boolean }) => {
    const showMergeInstruction = Boolean(isAdmin || isSupplier);
    // Expanded by default on the supplier's own screen; collapsed by default elsewhere (e.g. admin view). Not persisted between visits.
    const [expanded, setExpanded] = useState(Boolean(isSupplier));
    const toggleExpanded = () => setExpanded(current => !current);
    const handleHeaderKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleExpanded();
        }
    };

    return <div className="doc-list__upload-guidance" role="note">
        <div
            className="doc-list__upload-guidance-header"
            role="button"
            tabIndex={0}
            aria-expanded={expanded}
            onClick={toggleExpanded}
            onKeyDown={handleHeaderKeyDown}
        >
            <strong className="doc-list__upload-guidance-title"><FontAwesomeIcon icon={faInfoCircle} />Upload requirements:</strong>
            <span className="doc-list__upload-guidance-summary">{buildSummary(policy)}</span>
            <FontAwesomeIcon className="doc-list__upload-guidance-chevron" icon={expanded ? faChevronUp : faChevronDown} />
        </div>
        {expanded ? <div className="doc-list__upload-guidance-content">
            {!policy ? <span>Upload requirements are unavailable.</span> : <>
                {showMergeInstruction ? <span>If you have more than one policy please merge to one document.</span> : null}
                {isAdmin ? <span>Uploaded files should be reviewed carefully before approval.</span> : null}
            </>}
        </div> : null}
    </div>
};

export default SupplierDocumentUploadGuidance;